<template>
  <SfButton class="sf-button--pure microcart-icon" @click="openMicrocart">
    <SfIcon
      size="xs"
      icon="empty_cart"
      class="header__icon"
      :aria-label="$t('Open microcart')"
    >
      <template #badge>
        <SfBadge v-show="numberOfItems" class="sf-icon__badge sf-badge--number">
          {{ numberOfItems }}
        </SfBadge>
      </template>
    </SfIcon>
  </SfButton>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { syncOnLocalStorageChange } from "@lib/modules/cart/helpers";

import { SfIcon, SfButton, SfBadge } from "@lib/components";

export default {
  components: { SfIcon, SfButton, SfBadge },
  mounted() {
    syncOnLocalStorageChange.addEventListener();
    this.$once("hook:beforeDestroy", () => {
      syncOnLocalStorageChange.removeEventListener();
    });
  },
  computed: {
    ...mapGetters({
      numberOfItems: "cart/getNumberOfItems",
    }),
  },
  methods: {
    openMicrocart() {
      this.$store.dispatch("ui/toggleMicrocart");
    },
  },
  methods: {
    ...mapActions({
      openMicrocart: "ui/toggleMicrocart",
    }),
  },
};
</script>

<style lang="scss" scoped>
.microcart-icon {
  position: relative;
  .header__icon {
    cursor: pointer;
  }
}
</style>
